



























import { defineComponent, PropType } from '@vue/composition-api'
import CreateDialog from '~/components/CreateDialog.vue'
import { VueForm } from '~/utils/interfaces'
import {
  RemittanceBalance,
  RemittanceBalanceOperation,
} from '~/utils/interfaces/remittance.interface'
import vRules from '~/utils/vRules'
export default defineComponent({
  components: { CreateDialog },
  props: {
    balance: { type: Object as PropType<RemittanceBalance>, required: true },
    poster: {
      type: Function as PropType<
        (body: RemittanceBalanceOperation) => Promise<void>
      >,
      required: true,
    },
  },
  data() {
    return {
      crud: {
        amount: '',
        description: '',
      },
      vRules,
      model: false,
      loading: false,
    }
  },
  methods: {
    async onSuccess() {
      const form = this.$refs.form as VueForm
      if (!form.validate()) return
      const body = {
        ...this.crud,
        agency: this.balance.agency,
        delivery_currency: this.balance.delivery_currency,
      }
      try {
        this.loading = true
        await this.poster(body)
        this.$emit('new-operation')
        this.model = false
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    model(value: boolean): void {
      if (value) {
        this.crud = {
          amount: '',
          description: '',
        }
        const form = this.$refs.form as VueForm
        form?.resetValidation()
      }
    },
  },
})
